export default "__VITE_ASSET__QOLGRf9A__"